import { ContentState, convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import sanitizeHtml from 'sanitize-html';

// ensures that we're repopulating our DraftJS editor with the correct data from server
export const serializeHtmlToDraftJs = text => {
  const { contentBlocks, entityMap } = htmlToDraft(text, (nodeName, node) => {
    if (nodeName === 'iframe') {
      return {
        data: { code: node.outerHTML },
        mutability: 'IMMUTABLE',
        type: 'VIDEO',
      };
    }
    if (nodeName === 'img') {
      return {
        data: {
          src: node.src,
          width: node.width,
          height: node.height,
        },
        mutability: 'IMMUTABLE',
        type: 'IMAGE',
      };
    }
    return undefined;
  });

  return ContentState.createFromBlockArray(contentBlocks, entityMap);
};

// ensures that any DraftJS is properly being parsed to HTML that is server friendly
export const serializeDraftJsToHtml = editorState => {
  if (!editorState || typeof editorState !== 'object') throw new Error(`editorState must not be undefined`);
  const rawContentState = convertToRaw(editorState.getCurrentContent());

  const markup = draftToHtml(rawContentState, undefined, false, ({ type, data }) => {
    if (type === 'VIDEO') return data.code;
    if (type === 'IMAGE') return `<img src="${data.src}" width="${data.width}" height="${data.height}"></img>`;
    return undefined;
  });

  return sanitizeHtml(markup, {
    allowedTags: [
      'p',
      'img',
      'b',
      'i',
      'em',
      'strong',
      'a',
      'h1',
      'h2',
      'h3',
      'del',
      'li',
      'ol',
      'ul',
      'pre',
      'iframe',
    ],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
      img: ['src', 'width', 'height'],
      iframe: ['width', 'height', 'src', 'frameborder', 'allow', 'loading'],
    },
    allowedClasses: {
      iframe: ['allowfullscreen'],
    },
    selfClosing: [],
    allowedIframeDomains: ['youtube.com', 'twitch.tv', 'vimeo.com', 'dailymotion.com', 'spotify.com'],
  })
    .trim()
    .replace(/<\/img>/g, '') // req'd because web adds a self-closing tag on <img>, so use </img> and remove it instead
    .replace(/<a href=".+?"(\s)/g, '$&rel="nofollow" '); // req'd because DraftJS does not add nofollow on anchor tags
};
